import { sortBy } from 'lodash';

export const PROFILE_KEYWORDS = sortBy([
  'Build muscle',
  'Weight loss',
  'Toning',
  'Shred fat',
  'Athletic',
  'Lean muscle',
  'Performance',
  '6-pack',
  'No equipment',
  'Bodyweight',
  'Home',
  'Beginner',
  'Mom',
  'Strength',
  'Conditioning',
  'Functional',
  'Mobility',
  'Flexibility',
  'Stretching',
  'Endurance',
  'Recovery',
  'Classes',
  'Crossfit',
  'Kettlebell',
  'Tabata',
  'Barre',
  'Pilates',
  'Yoga',
  'Boxing',
  'HIIT',
  'Cardio',
  'Pre/post natal',
  'Bikini Body',
  'Abs and Core',
  'Booty',
  'Full Body',
  'Celebrity',
  'Coaching',
  'Meditation',
  'Basketball',
  'Soccer',
  'Weight lifting',
]);
